import React from 'react';
import Icon from './Icon';

const ChevronRight = (props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <title>Chevron Right</title>
    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
    <path d="M0 0h24v24H0z" fill="none"/>
  </Icon>
);

export default ChevronRight;
